import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(tz)


//dayjs.tz.setDefault("Europe/Vienna")

/**
 * @param {int} timestamp
 * @param {boolean} withBr
 * @param {boolean} withoutTime
 */
const convertDateManual = (timestamp, withBr=false, withoutTime=false) => {
  let date = dayjs( new Date(parseInt(timestamp, 10) * 1000) ).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
  let format = 'YYYY-MM-DD HH:mm:ss';
  if( withBr ) {
    format = 'YYYY-MM-DD<br>HH:mm:ss';
  }
  if( withoutTime ) {
    format = 'YYYY-MM-DD';
  }
  return dayjs.utc(date).local().format(format)
}


const convertDateCE = (timestamp, withBr=false, withoutTime=false) => {

  const currentDate = new Date(parseInt(timestamp, 10) * 1000)
  var a = dayjs(currentDate)
  let dateTz = a.utc().tz("Europe/Vienna")
  let format = 'YYYY-MM-DD HH:mm:ss';
  if( withBr ) {
    format = 'YYYY-MM-DD<br>HH:mm:ss';
  }
  if( withoutTime ) {
    format = 'YYYY-MM-DD';
  }

  return dateTz.format(format)
}


const convertDateObject = (timestamp) => {
  const currentDate = new Date(parseInt(timestamp, 10) * 1000)
  var a = dayjs(currentDate)
  let dateTz = a.utc().tz("Europe/Vienna")
  return dateTz.format()
}



const convertDateBeforeSend = (date) => {
  //console.log('convertDateBeforeSend')

  var a = dayjs(date)
  return a.format('YYYY-MM-DD HH:mm:ss')

  /*var a = dayjs.unix(date)

  let dz = a.tz("Europe/Vienna")

  console.log(dz.format())

  console.log('unix', dz.unix())

  /!*let dt1 = new Date(dz.format())
  console.log(dt1.getTime()/1000)*!/

  return dz.unix()*/
}



const convertDateAuto = () => {
  /*const dateElements = document.querySelectorAll('[data-dayjs-timestamp]')
  dateElements.forEach((element)=>{
    let withBr = false
    if( element.hasAttribute('data-dayjs-with-br') ) {
      withBr = true
    }
    let withoutTime = false
    if( element.hasAttribute('data-dayjs-without-time') ) {
      withoutTime = true
    }
    element.innerHTML = convertDateManual(element.getAttribute('data-dayjs-timestamp'), withBr, withoutTime)
  })*/
}

const convertDateToUTC = (timestamp) => {
  //console.log(timestamp)
  var a = dayjs.unix(timestamp)

  let dateTz = a.tz("UTC", true)
  //console.log(dateTz.format('YYYY-MM-DD HH:mm:ss'))
  //console.log(dateTz.unix())

  return dateTz.unix()
}


export {
  convertDateManual,
  convertDateAuto,
  convertDateObject,
  convertDateCE,
  convertDateBeforeSend,
  convertDateToUTC
}

